export function workspacesPageFragment({ workspaceId }) {
  return `workspaces/${workspaceId}`;
}

export function navigateToWorkspace({ router, workspaceId }) {
  const fragment = workspacesPageFragment({ workspaceId });
  router.navigate(fragment, { trigger: true });
}
